import React from 'react'
import './nav.css'
import {FaHome} from 'react-icons/fa'
import {AiOutlineUser} from 'react-icons/ai'
import {BsFillBookmarkStarFill} from 'react-icons/bs'
import {RiCustomerServiceFill} from 'react-icons/ri'
import {RiContactsLine} from 'react-icons/ri'
import { useState } from 'react'

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#');
  return (
   <nav>
     <a href='/#' onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ''} data-tooltip="Home"><FaHome/></a>
     <a href='#about' onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''} data-tooltip="About"><AiOutlineUser/></a>
     <a href='#experience' onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''} data-tooltip="Skills"><BsFillBookmarkStarFill/></a> 
     <a href='#services'  onClick={() => setActiveNav('#services')} className={activeNav === '#services' ? 'active' : ''} data-tooltip="Services"><RiCustomerServiceFill/></a>
     <a href='#contact' onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''} data-tooltip="Contact"><RiContactsLine/></a> 
   </nav>
  )
}

export default Nav
